export const changeToIst = (date) => {
    const localTime = new Date(date)
    const year = localTime.getFullYear()
    const month = (localTime.getMonth() + 1).toString().padStart(2, '0')
    const selectedDate = localTime.getDate().toString().padStart(2, '0')

    return `${year}-${month}-${selectedDate}`
}
